// index.js or main file
import React, { Suspense, lazy, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Login from './pages/login/login';
import AdminRedirect from './adminRedirect/admin';
import Admin from './admin/admin';
import Home from './admin/pages/home/home';
import Rules from './admin/pages/rules/rules';
import { Provider } from 'react-redux';
import { store } from './admin/store';
import LoginPage from './admin/pages/login/login';
import ThankYou from './pages/thankyou/thankyou';
import USER from './pages/dddUI/user';
import Editor from './admin/pages/editor/editor';

// loaded on demand so the game's styles and engine stay out of the login/admin bundle
const GamePage = lazy(() => import('./pages/game/GamePage'));
const GameLeaderboard = lazy(() => import('./pages/game/GameLeaderboard'));

function usePageBackground() {
  const location = useLocation();
  useEffect(() => {
    const body = document.body;
    const path = location.pathname;
    /** Routes that set their own full-viewport theme image — skip index.css `common-bg` (img/background.jpg) to avoid double layers */
    const ownBackdrop =
      /^\/game\/?$/i.test(path);
    if (path.startsWith("/admin")) {
      body.classList.remove("common-bg");
    } else if (ownBackdrop) {
      body.classList.remove("common-bg");
    } else {
      body.classList.add("common-bg");
    }
  }, [location]);
}

function App() {
  usePageBackground();
  // fixed tab title on every page (nothing else may rename it)
  const { pathname } = useLocation();
  useEffect(() => {
    document.title = 'Big Boss Customer Centric League';
  }, [pathname]);

  return (
    <Provider store={store}>
      <Routes>
        {/* Explicit paths (most specific first) so /admin always = theme admin, never the superadmin login */}
        <Route path="/admin/superadmin" element={<LoginPage />} />
        <Route path="/admin/rules" element={<Admin><Rules /></Admin>} />
        <Route path="/admin/editor" element={<Admin><Editor /></Admin>} />
        <Route path="/admin" element={<Admin><Home /></Admin>} />

        <Route path="/rules" element={<Navigate to="/game" replace />} />
        <Route path="*" element={
          <USER>
            <Routes>
              <Route index element={<Login />} />
              <Route path="/login" element={<Login />} />
              <Route path="/game" element={<Suspense fallback={null}><GamePage /></Suspense>} />
              <Route path="/AdminRedirect" element={<AdminRedirect />} />
              <Route path="/thankyou" element={<ThankYou />} />
              <Route path="/leaderboard" element={<Suspense fallback={null}><GameLeaderboard /></Suspense>} />
            </Routes>
          </USER>
        } />
      </Routes>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

reportWebVitals();
